import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const teaDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "tea-detect-example",
  version: 1,
  title: "Robotics",
  description: "Ground precise points",
  subdescription: "Find exact contact points for a pouring task from a first-person view.",
  thumbnailUuid: BASE_ASSETS.egocentricKettlePourExample.uuid,
  assets: [BASE_ASSETS.egocentricKettlePourExample],
  detect: {
    mediaUuid: BASE_ASSETS.egocentricKettlePourExample.uuid,
    categories: ["tip of spout", "hands", "where stream of water enters tea"],
    config: {
      output: "box",
    },
  },
};
